
import React from 'react';
import SignupForm from '../Components/SignupForm/SignupForm';
function Signup() {
  return (
    <div className='d-flex justify-content-center  h-100'>

<SignupForm/>
    </div>
  )
}

export default Signup